document.addEventListener('DOMContentLoaded', function () {
  const targetBtn = document.querySelector('.product__description .accordion__button');

  if (!targetBtn) return;

  // Prevent double-trigger
  if (!targetBtn.classList.contains('is-opened')) {
    setTimeout(() => {
      targetBtn.click();
    }, 300); // slight delay to ensure theme JS is ready
  }
});